import { Dispatch, useCallback } from "react";
import { LeadActions, LeadActionUnion } from "./Lead.Actions";
import LeadService from "../../Data/Services/LeadService";
import { ILeadEffects } from "./Interfaces/ILeadEffects";
import { ISaveLead } from "../../Data/Interfaces/Request/Lead/ISaveLead";
import { FormikHelpers, FormikValues } from "formik";
import { IResponse } from "../../Data/Interfaces/Base/IResponse";
import { IResponseLead } from "../../Data/Interfaces/Responses/Lead/IResponseLead";

export type LeadEffectsType = (
  dispatch: Dispatch<LeadActionUnion>
) => ILeadEffects;

export const LeadEffects: LeadEffectsType = (
  dispatch: Dispatch<LeadActionUnion>
) => ({
  saveLead: useCallback(
    async (
      compra: ISaveLead,
      helpers: FormikHelpers<FormikValues>,
      showSuccessMessage: () => void
    ) => {
      try {
        dispatch(LeadActions.setLoading(true));
        const { data } = await LeadService.fetchLead(compra);
        const result = data as IResponse<IResponseLead>;
        dispatch(LeadActions.saveLeadSuccess(result));
        helpers.setSubmitting(false);
        showSuccessMessage();
      } catch (err: any) {
        dispatch(LeadActions.saveLeadFailed(err));
        helpers.setErrors(err);
        helpers.setSubmitting(false);
      } finally {
        dispatch(LeadActions.setLoading(false));
      }
    },
    [dispatch]
  ),
});
